export default "__VITE_ASSET__4cqClHdo__"